import EventEmitter from 'events'
import { gsap } from 'gsap/all'

export default class Home extends EventEmitter {
  constructor() {
    super()

    this.scroll = 0;
    this.progress = 0;
    this.windowHeight = window.innerHeight;
    this.background = document.querySelector('.js-background');
    
    window.addEventListener('scroll', () => {
      this.scroll = window.pageYOffset;
      this.progress = this.limiter(this.scroll / this.windowHeight);
      this.background.style.filter = `blur(${this.progress * 5}px)`;
      this.background.style.transform = `scale(${1 + this.progress * 0.02})`;
      this.background.style.opacity = 1 - this.progress * 0.8;
      // console.log(this.progress);
    });
  }
  
  limiter(val) {
    return (val > 1) ? 1 : val;
  }
}
